import classNames from 'classnames';
import { ChangeEvent, FC } from 'react';

import './style.scss';

export type RadioGroupLabelledProps = {
  id: string;
  label: string;
  options: ReadonlyArray<{ value: string; label: string }>;
  value: Nullable<string>;
  onValueChanged: (value: string) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isHighlighted?: boolean;
  isReadOnly?: boolean;
};

export const RadioGroupLabelled: FC<RadioGroupLabelledProps> = ({
  id,
  label,
  options,
  value,
  onValueChanged,
  isDisabled = false,
  isInvalid = false,
  isHighlighted = false,
  isReadOnly = false,
}) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue !== value) {
      onValueChanged(newValue);
    }
  };

  return (
    <div
      className={classNames('radio-group-container input-group bg-lvl1 d-flex flex-column', {
        'border-bottom border-warning': isInvalid,
        'border-bottom border-info': isHighlighted,
      })}
    >
      <div className="label input-icon-start w-auto px-12px">
        <label htmlFor={id} className="text-secondary fs-5">
          {label}
        </label>
      </div>
      <div
        className="radio-group btn-group gap-2 ps-3 fs-1 fw-medium w-100 flex-wrap"
        role="radiogroup"
        aria-labelledby={id}
      >
        {options.map(option => (
          <div className="form-check form-check-md" key={option.value}>
            <input
              className="form-check-input"
              id={`radio-${id}-${option.value}`}
              type="radio"
              name={id}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
            />
            <label
              className={`form-check-label border ${value === option.value ? 'active border-primary text-primary' : 'radio-label'}`}
              htmlFor={`radio-${id}-${option.value}`}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
